import React from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config/config'

const TeamMember = ({ member }) => {
  const { i18n, t } = useTranslation()
  const lang = i18n.language

  const getTranslatedField = (field) =>
    member[`${field}${lang.charAt(0).toUpperCase() + lang.slice(1)}`] || ''

  {
    /* Pour ajouter un membre il suffit de l'ajouter dans la table team member */
  }
  {
    /* Pour mettre une photo il suffit de la placer dans le dossier côté back photos/mediumImage et de mettre l id de la photo en bdd */
  }
  const imageUrl = `${config.photoUrlMedium}${member.photoId}.jpg`

  return (
    <div className="team-member block-wrapper" style={{ padding: '0' }}>
      <div className="team-member-header">
        <h4 className="team-member-name">{member.name}</h4>
      </div>

      <div className="team-member-role">
        <strong>{getTranslatedField('title')}</strong>
      </div>

      {member.photoId && (
        <div className="team-member-photo">
          <img src={imageUrl} alt={member.name} className="img-fluid rounded" />
        </div>
      )}

      <ul className="team-member-description ul-square">
        {[1, 2, 3, 4, 5].map((num) => {
          const desc = getTranslatedField(`description${num}`)
          return desc ? <li key={num}>{desc}</li> : null
        })}
      </ul>

      {member.favoritePlaceFr && (
        <p className="team-member-favorite">
          <strong>{t('FAVORITE_PLACE')}:</strong>{' '}
          {getTranslatedField('favoritePlace')}
        </p>
      )}
    </div>
  )
}

export default TeamMember
